/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/7-free-sites-for-frontend-developers",
  title: "7 free sites for frontend developers",
  description: `7 FREE Sites For Front-End Developers You Probably Didn't Know Existed 

Thread 🧵👇`,
  image: "/covers/threads/7-free-sites-for-frontend-developers.png",
  author: "Csaba Kissi ⚡"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Csaba Kissi ⚡",
      username: "csaba_kissi",
      avatarUrl: "/avatars/csaba_kissi.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/csaba_kissi/status/1455122114265092097"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "7 FREE Sites For Front-End Developers You Probably Didn't Know Existed"
      }), _jsx(_components.p, {
        children: "Thread 🧵👇"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/7-free-sites-for-frontend-developers-1.png`,
      children: [_jsx(_components.p, {
        children: "1️⃣ uiGradients - Beautiful colored gradients"
      }), _jsx(_components.p, {
        children: "uiGradients is a handpicked collection of beautiful color gradients for designers and developers."
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://uigradients.com/#ViceCity",
          children: "https://uigradients.com/#ViceCity"
        })
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/7-free-sites-for-frontend-developers-2.png`,
      children: [_jsx(_components.p, {
        children: "2️⃣ Compressio App"
      }), _jsx(_components.p, {
        children: "Compressio App is an Open Source Production Grade Image Compression Web Application. It compresses JPG, PNG, GIF & SVG images in both Lossy and Lossless formats."
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://compressio.app/",
          children: "https://compressio.app/"
        })
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/7-free-sites-for-frontend-developers-3.png`,
      children: [_jsx(_components.p, {
        children: "3️⃣ Obsidian: A knowledge base that works on local Markdown files."
      }), _jsx(_components.p, {
        children: "Obsidian – A knowledge base that works on local Markdown files."
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://obsidian.md/",
          children: "https://obsidian.md/"
        })
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/7-free-sites-for-frontend-developers-4.png`,
      children: [_jsx(_components.p, {
        children: "4️⃣ Localstack"
      }), _jsx(_components.p, {
        children: "💻 A fully functional local AWS cloud stack. Develop and test your cloud and Serverless apps offline!"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://github.com/localstack/localstack",
          children: "https://github.com/localstack/localstack"
        })
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/7-free-sites-for-frontend-developers-5.png`,
      children: [_jsx(_components.p, {
        children: "5️⃣ Flatmap:"
      }), _jsx(_components.p, {
        children: "Fast and flexible tool to build vector tiles from OpenStreetMap data"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://github.com/onthegomap/planetiler",
          children: "https://github.com/onthegomap/planetiler"
        })
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/7-free-sites-for-frontend-developers-6.png`,
      children: [_jsx(_components.p, {
        children: "6️⃣ Cleanup.pictures"
      }), _jsx(_components.p, {
        children: "Remove objects, people, text, and defects from any picture - 100% free. Create a clean background for a product picture, re-design any items, fill up some missing space for a youtube thumbnail."
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://cleanup.pictures/",
          children: "https://cleanup.pictures/"
        })
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/7-free-sites-for-frontend-developers-7.png`,
      children: [_jsx(_components.p, {
        children: "7️⃣ Wasp | Wasp"
      }), _jsx(_components.p, {
        children: "A simple language for developing full-stack web apps with less code."
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://wasp-lang.dev/",
          children: "https://wasp-lang.dev/"
        })
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "If you want to receive a summary of my best resources you can even subscribe to my weekly newsletter:\ncsabakissi.com/nl"
      }), _jsx(_components.p, {
        children: "That's all guys."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "If you found this list useful, consider:"
      }), _jsx(_components.p, {
        children: "✅ Follow @csaba_kissi for more content like this\n🔔 Enable notifications 👀\n🔄 Retweeting the first tweet."
      }), _jsx(_components.p, {
        children: "Thanks for your support guys! 🙏🤝"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "This premium course from @traversymedia and @study_web_dev can be a game-changer for your freelance career.👇"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://freelancemastery.dev/p/freelance-mastery-for-developers-premium/?affcode=1074889_kslq3yry",
          children: "https://freelancemastery.dev/p/freelance-mastery-for-developers-premium/?affcode=1074889_kslq3yry"
        })
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
